import React, {Component} from 'react';
import './styles.css';
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import EpicMenu from '../Menus/EpicMenu';
import {Inject, ScheduleComponent, Week, Month, Agenda, ViewsDirective, ViewDirective} from '@syncfusion/ej2-react-schedule';

class Calendario extends Component{
	constructor(props){
		super(props);
		this.app= firebase;
		this.database = this.app.firestore().collection('Tareas')

		this.state = {
			pendientes: [],
		}
	}

	componentDidMount(){
		this.database.orderBy('fechaFin').onSnapshot(querySnapshot =>{
			this.setState({pendientes:[]})
			querySnapshot.forEach(doc=>{
				const previousAct = this.state.pendientes;
				previousAct.push({
					id: doc.id,
					lugarPendiente: doc.data().lugarPendiente,
					lugarCompletado:doc.data().lugarCompletado,
					zona:doc.data().zona,
					tunel:doc.data().tunel,
					tipoPago: doc.data().tipoPago,
					personas: doc.data().personas,
                    status: doc.data().status,
                    
                    Subject: doc.data().actividad,
                    Description: doc.data().descripcion,
                    StartTime: doc.data().fechaInicio.toDate(),
                    EndTime: doc.data().fechaFin.toDate(),
                    IsAllDay: true,
                    Priority: 'High'
				})
				this.setState({
					pendientes: previousAct
				})
			})
        })
    }

    render() {
        return (
        <div>
            <div className='header'>
				<EpicMenu />
				<div className='inline'>Calendario</div>
			</div>
            <div className='body'>
                <link href="https://cdn.syncfusion.com/ej2/material.css" rel="stylesheet" type="text/css" />

                <ScheduleComponent readonly={true} editable={false} 
                width='100%' height='550px' currentView='Month' 
                eventSettings={{dataSource: this.state.pendientes,
                fields:{
                    id: 'id',
                    subject: { name: 'Subject' },
                    descripcion: { name: 'Description'},
                    isAllDay: { name: 'IsAllDay' },
                    startTime: { name: 'StartTime' },
                    endTime: { name: 'EndTime' }
                }
                }}>
                    <ViewsDirective>
                        <ViewDirective option='Week' />
                        <ViewDirective option='Month' />
                        <ViewDirective option='Agenda' />
                    </ViewsDirective>
                    <Inject services={[Week, Month, Agenda]} />
                </ScheduleComponent>
            </div>
            <div className="footer" >
				<div className="footer1" >
				</div>
				<div className="footer2" ></div>
			</div>
        </div>
        )
    }
}

export default Calendario;